import { DELETE, FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

const BASE_URL =
    "https://gestiondeflota.boltrack.net/apiultimamillav3/api/acciones-kanban-usuario";

export async function crearAccionesKanbanUsuario(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            `${BASE_URL}/crear-acciones-kanban-usuario`,
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("crearAccionesKanbanUsuario err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function obtenerListaAccionesKanbanUsuario(obj) {
    try {
        let data = [];
        const { code, body } = await fetch(
            `${BASE_URL}/obtener-lista-acciones-kanban-usuario`,
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (code === SUCCESS && Array.isArray(body)) {
            data = body;
        }
        return data;
    } catch (err) {
        console.log("obtenerListaAccionesKanbanUsuario err");
        console.log(err);
        return [];
    }
}

export async function eliminarAccionesKanbanUsuario(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            `${BASE_URL}/eliminar-acciones-kanban-usuario`,
            {
                headers: getHeaders(),
                method: DELETE,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("eliminarAccionesKanbanUsuario err");
        console.log(err);
        return { error: true, message: err };
    }
}
